import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LinearProgress from 'material-ui/LinearProgress';

import Fetcher from '../../util/fetcher';
import StepProps from '../../constants/StepProps';

// TODO: Something in this component seems to be causing a warning in the React console.
// Warning: setState(...): Cannot update during an existing state transition 
class PoiStepProcessing extends Component {
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
  };

  static propTypes = StepProps;

  componentDidMount() {
    this.props.onValidationChange(false);
    this.pollStatus();
  }

  /**
   * Whenever an error occurs, notify the stepper component
   * @param {Object} error
   */
  processFailed = (error) => {
    const { onStepCompleteFailed } = this.props;
    this.props.onValidationChange(true);
    onStepCompleteFailed(error);
  }

  /**
   * Delayed call to amplify status poll
   *
   * @param {Object} response 
   */
  delayedPollStatus = (response) => {
    // Here we check if the pollStatus should be called again, or if we are finished:
    if (response && response.data && response.data.done) {
      this.processPoiMatchCompleted();
    } else {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.pollStatus, 5000);
    }
  }

  /**
   * When the load has succesfully completed, we should keep monitoring the BQ job that does the amplification.
   * We do this by polling.
   *
   * @param {Object} response 
   */
  pollStatus = () => {
    const { hash } = this.props;

    Fetcher.init(this.context.firebaseToken)
      .poiProcessStatus(hash, this.context.dataset)
      .then(this.delayedPollStatus)
      .catch(this.processFailed);
  }

  /**
   * When we are done with both the load and the amplification process, continue.
   */
  processPoiMatchCompleted = () => {
    const { onValidationChange, onStepCompleteSuccess } = this.props;
    onValidationChange(true);
    onStepCompleteSuccess();
  }

  render() {
    return (
      <div>
        <br/>
        <p>Your data is being processed. This could take several minutes.</p>
        <LinearProgress mode="indeterminate" />
        <br/>
        <br/>
      </div>
    );
  }
}
export default PoiStepProcessing;



// WEBPACK FOOTER //
// ./src/components/PoiStepProcessing/index.jsx